import script from "./ErrorListDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorListDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorListDialog.vue?vue&type=style&index=0&id=fc495862&lang=scss"

const __exports__ = script;

export default __exports__